import * as axios from 'axios';
import qs from 'qs';

const defaultConfig = {
  xsrfCookieName: 'X-XSRF-TOKEN',
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    credentials: 'same-origin',
    'content-type': 'application/json',
  },
};

const client = axios.create({
  ...defaultConfig,
  validateStatus: status => status <= 400,
});

const contextRoot = () =>
  location.hostname !== 'localhost' &&
  location.hostname !== '127.0.0.1' &&
  window.initialAppState.pathContext
    ? window.initialAppState.pathContext
    : '';

const config = {
  headers: {
    ...defaultConfig.headers,
    'X-XSRF-TOKEN': window.initialAppState.xsrfToken,
  },
  paramsSerializer: params => {
    return qs.stringify(params);
  },
};

const Api = {
  contextRoot: () => `${contextRoot()}`,
  post: (url, body) => client.post(`${contextRoot()}/api/${url}`, body, config),
  put: (url, body) => client.put(`${contextRoot()}/api/${url}`, body, config),
  get: (url, params) => {
    return client.get(
      `${contextRoot()}/api/${url}`,
      params
        ? {
            ...config,
            params: {
              ...params
            }
          }
        : config,
    );
  },
  delete: (url, params) =>
    client.delete(
      `${contextRoot()}/api/${url}`,
      params ? { ...config, ...params } : config,
    ),
};

export default Api;
